import { Box, Button, Typography } from "@mui/material";
import { useQuery } from "react-query";
import { useEffect, useState } from "react";
import MultiSelect from "src/components/common/MultiSelect";
import ProgressCard from "src/components/common/ProgressCard";
import DashboardChartSkeleton from "src/components/common/DashboardChartSkeleton";
import { getProgressReportDetails } from "src/utils/api/dashboard";
import { getStyles } from "src/styles/theme";
import defaultStyles from "./styles";
import { getStates } from "src/utils/api/roles";
import { DashBoardTable } from "src/components/common/DashBoardTable";
import { ProgressDetailReport } from "src/components/common/DashBoardTable/progressDetailReport";
import { AxiosError, AxiosResponse } from "axios";
import { usePersistedFilters } from "src/hooks/usePersistedFilters";
import { useEntityOptions } from "src/hooks/useEntityOptions";
import { exportProgressReportTableToXlsx } from "src/utils/helper";

const ProgressReport = () => {
  const [states, setStates] = useState<any>([]);
  const [filtersState, setFiltersState] = useState([]);

  const { persisted, saveFilters } = usePersistedFilters("mw_progressReport");

  const [entityfilterKey, entitySetFilterKey] = useState(
    persisted?.entityfilterKey ?? { enetityStateIds: null }
  );

  const [tableRows, setTableRows] = useState([]);

  const [queryParams, setQueryParams] = useState<{
    progressReportFormat: string;
    indicatorIds?: string;
    entityIds?: string;
  }>({
    progressReportFormat: "TABLE",
    entityIds: persisted?.queryParams?.entityIds ?? undefined,
  });

  const [boxQueryParams, setBoxQueryParams] = useState<{
    projectStateIds?: string[];
    progressReportFormat?: string;
  }>({
    projectStateIds: persisted?.boxQueryParams?.projectStateIds ?? undefined,
    progressReportFormat: "BOX",
  });

  const { data: dashboard, isLoading: dashboardLoading } = useQuery(
    ["ProgressReportDetails", boxQueryParams],
    () => getProgressReportDetails(boxQueryParams),
    {
      refetchOnMount: true,
    }
  );

  useQuery(["getStatesType"], () => getStates(), {
    onSuccess: (data) => {
      setStates(data.data);
    },
    refetchOnMount: true,
  });

  const { data: dashboardTable, isLoading: dashboardLoadingTable } = useQuery(
    ["ProgressReportDetailstable", queryParams],
    () => getProgressReportDetails(queryParams),
    {
      onSuccess: (res) => {
        if (res) {
          setTableRows(
            res?.data?.data?.progress.map((items, idx) => ({
              id: idx,
              sno: idx + 1,
              state: items.state,
              indicatorName: items.indicatorName,
              targetInUnits: items.targetInUnits,
              costTarget: items.costTarget,
              progressInUnits: items.progressInUnits,
              costProgress: items.costProgress,
              redirectionKeyValue: items.redirectionKeyValue,
              indicatorId: items.indicatorId,
            }))
          );
        }
      },
      refetchOnMount: true,
    }
  );

  const handleCardClick = (indicatorId: string) => {
    setQueryParams((prevFilter) => {
      const newState = {
        ...prevFilter,
        indicatorIds: indicatorId,
      };
      return newState;
    });
  };

  const dashboardTableData: DashBoardTable = {
    topHeader: ["", "Target", "Progress"],
    header: [
      "S.No",
      "State",
      "Activity Name",
      "Physical",
      "Finanical",
      "Physical",
      "Finanical",
    ],
    data: tableRows,
  };

  const styles = getStyles(defaultStyles);

  const { entityInfo } = useEntityOptions();

  useEffect(() => {
    setFiltersState(dashboard?.data?.state);
  }, [dashboard]);

  useEffect(() => {
    saveFilters({ queryParams, boxQueryParams, entityfilterKey });
  }, [queryParams, boxQueryParams, entityfilterKey]);

  return (
    <>
      <Box {...styles("topHeader")}>
        <Box sx={{ display: "flex", gap: "8px" }}>
          <MultiSelect
            options={states}
            value={boxQueryParams.projectStateIds}
            onChange={(e: any) => {
              const projectStateIds = e.length ? e : null;
              setQueryParams((prev) => ({
                ...prev,
                projectStateIds,
              }));
              setBoxQueryParams((prev) => ({
                ...prev,
                projectStateIds,
              }));
            }}
          />
          <MultiSelect
            options={entityInfo}
            label={"Filter By Entity"}
            value={entityfilterKey.entityIds}
            onChange={(e: any) => {
              entitySetFilterKey((prevFilter) => {
                const newState = {
                  ...prevFilter,
                  entityIds: e.length ? e : null,
                };

                setQueryParams({
                  ...queryParams,
                  entityIds: newState?.entityIds,
                });

                return newState;
              });
            }}
          />
        </Box>
        <Box {...styles("statsCardWrapper", { marginTop: "20px" })}>
          {dashboard?.data?.data?.progress?.map((stat, index) => (
            <ProgressCard
              key={index}
              title={`${stat?.indicatorName?.toUpperCase()}`}
              value={`${stat?.costProgress}`}
              area={stat?.progressInUnits}
              customStyles={{ valueCard: styles("statsCard").sx }}
              id={stat?.indicatorId}
              onClick={handleCardClick}
            />
          ))}
        </Box>
      </Box>
      {dashboardLoadingTable ? (
        <DashboardChartSkeleton showChart={false} />
      ) : (
        <Box {...styles("dashboardTableWrapper")}>
          <Box sx={{ display: "flex", justifyContent: "space-between" }}>
            <Typography variant="h5" {...styles("heading")}>
              Status of Progress Detials
            </Typography>
            <Button
              variant="outlined"
              onClick={() =>
                exportProgressReportTableToXlsx(
                  dashboardTableData.data,
                  dashboardTableData.header,
                  dashboardTableData.topHeader
                )
              }
            >
              Export
            </Button>
          </Box>
          <ProgressDetailReport {...dashboardTableData} />
        </Box>
      )}
    </>
  );
};

export default ProgressReport;
